import React,{ useEffect } from 'react';
import Button from 'jd-library/Button';
import styles from './add-edit-product.scss';
import Popover from 'jd-library/Popover';
import CustomScrollBar from 'jd-library/CustomScrollBar';

let scrollHeightList = ['53px','53px','106px','159px','34vh']

const AuditButtonComponent = props => {
    const [startPopoverRef, setStartPopoverRef] = React.useState('');
    const [auditorWebsites, setAuditorWebsites] = React.useState([]);
    const [scrollRef,setScrollRef] = React.useState(null);
    const [topFakeDiv,setTopFakeDiv] = React.useState(null);
    const [bottomFakeDiv,setBottomFakeDiv] = React.useState(true);
    let DisplayBtn = [];
    let count = (Object.keys(props.btnArr).length + 1);
    let width = ((100/count) - 2)+'%';
    let style = {
        width:width
    };
    let websiteStyle = {
        position:"relative",
        width:width
    }
    let customScrollBarHeight = {
        'min-height' : scrollHeightList[auditorWebsites.length] || "34vh"
    }
    const websiteRedirect = (e,url) => {
        e.stopPropagation();
        url && window.open(url, "_blank");
    }

    let startList = props.AuditWebsiteBtn[0] || [];

    useEffect(()=>{
        let auditWebsites = [];
        let bestPracticeUrls = (startList[1].jdBestPracticeWebsiteUrl && startList[1].jdBestPracticeWebsiteUrl.split(",")) || [];
        let ownerWebsitesUrls = (startList[0].jdWebsiteUrl && startList[0].jdWebsiteUrl.split(",")) || [];
        if(bestPracticeUrls.length){
            bestPracticeUrls.forEach((value,index) => {
                auditWebsites.push({
                    type:"BP"+(index + 1),
                    value:value
                })
            })
        }
        if(ownerWebsitesUrls.length){
            ownerWebsitesUrls.forEach((value,index) => {
                auditWebsites.push({
                    type:"OW"+(index + 1),
                    value:value
                })
            })
        }
        setAuditorWebsites(auditWebsites);
    },props.AuditWebsiteBtn);

    const getPopoverList = () =>{
        let displayData = [];
        auditorWebsites.map((item) => {
            displayData.push(
                <div className={styles['data-list-holder']}>
                    <div className={styles['data-list-title']}>
                       <span className={styles['data-list-type']}>{item.type}</span>
                    </div>
                    {item.value && (<div className={styles['data-list-url']} onClick = {(event) => {websiteRedirect(event,item.value)}}>
                        {item.value}
                    </div>)
                    }
                </div>
            )
        })
        return displayData;
    }

    if((startList[0] && startList[0].jdWebsiteUrl) || (startList[1] && startList[1].jdBestPracticeWebsiteUrl)){
        DisplayBtn.push(
            <div style={websiteStyle} className ={'website-option'}>
                <Popover 
                    content={(
                            props.fromListingPage ? (<>
                            {(auditorWebsites.length > 4 && topFakeDiv) ? <div className = {'websites-top-fake-list'}></div> : null}
                            <CustomScrollBar
                            style={customScrollBarHeight}
                            onScroll={()=>{
                                if(scrollRef && scrollRef.current){
                                    let scrollHeight = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
                                    if(scrollRef.current.scrollTop > 25){
                                        setTopFakeDiv(true);
                                    }else{
                                        setTopFakeDiv(false);
                                    }
                                    if((scrollHeight - scrollRef.current.scrollTop) > 25){
                                        setBottomFakeDiv(true);
                                    }else{
                                        setBottomFakeDiv(false);
                                    }
                                }
                            }}
                            updateScrollContRef = {(e) => {
                                setScrollRef(e)
                            }}>
                                <div className = {'websites-container'}>
                                    {getPopoverList()}
                                </div>
                            </CustomScrollBar>
                            {(auditorWebsites.length > 4 && bottomFakeDiv) ? <div className = {'websites-bottom-fake-list'}></div> : null}</>
                            ) : <div className = {'websites-container'}>{getPopoverList()}</div>
                    )}
                    containerEle={startPopoverRef}
                    className="websites-popover"
                    contentClass="websites-content-popover"
                    eventType='click'
                    fixToBottom = {true}>
                    <Button 
                        className={styles['audit-btn']}
                        variant="default" style={{width:"100%"}}
                    >
                            Website
                    </Button>
               </Popover>
            </div>
        )
    }else{
        DisplayBtn.push(<Button style={{...style,opacity: '0.5',color: '#0086FF', borderColor: '#0086FF'}} disabled variant="default" className={styles['audit-btn']}>Website</Button>)
    }

    props.btnArr.map((value) =>{
        DisplayBtn.push(<Button variant="default" style={style} clickHandler={value.onClick} className={styles['audit-btn']}>{value.name}</Button>)
    })

    return (
        ( <div className={styles['button-holder']} ref={r => setStartPopoverRef(r)}>
            {DisplayBtn}
        </div>)
    );
};


export default AuditButtonComponent;